import { Component, Input, OnInit } from '@angular/core';
import { IAuthorInfoDTO } from '@core/model';

@Component({
    selector: 'app-author-info',
    templateUrl: './author-info.component.html',
    styleUrls: ['./author-info.component.scss'],
    standalone: false
})
export class AuthorInfoComponent implements OnInit {
  @Input() data: IAuthorInfoDTO;
  @Input() createdBy: string;

  label = 'Author';

  ngOnInit() {
    this.label = this.createdBy || this.label;
  }
}
